
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/math",
      function () {
        return require("private-next-pages/courses/math.tsx");
      }
    ]);
  